var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "card-body",
      attrs: { role: "form" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.onUpdateUserPreferences($event)
        }
      }
    },
    [
      _c("div", { staticClass: "form-group" }, [
        _c("label", [_vm._v(_vm._s(_vm.T.userEditProfileImage))]),
        _c(
          "a",
          {
            staticClass: "btn btn-link",
            attrs: {
              href: "http://www.gravatar.com",
              target: "_blank",
              "data-email": ""
            }
          },
          [
            _vm._v(
              " " +
                _vm._s(_vm.T.userEditGravatar) +
                " " +
                _vm._s(_vm.email) +
                " "
            )
          ]
        )
      ]),
      _c("div", { staticClass: "form-group" }, [
        _c("label", [_vm._v(_vm._s(_vm.T.userEditLanguage))]),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.locale,
                expression: "locale"
              }
            ],
            staticClass: "custom-select",
            attrs: { "data-locale": "", "data-preference-language": "" },
            on: {
              change: function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.locale = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              }
            }
          },
          [
            _c("option", { attrs: { value: "es" } }, [
              _vm._v(_vm._s(_vm.T.wordsSpanish))
            ]),
            _c("option", { attrs: { value: "en" } }, [
              _vm._v(_vm._s(_vm.T.wordsEnglish))
            ]),
            _c("option", { attrs: { value: "pt" } }, [
              _vm._v(_vm._s(_vm.T.wordsPortuguese))
            ])
          ]
        )
      ]),
      _c("div", { staticClass: "form-group" }, [
        _c("label", [
          _vm._v(_vm._s(_vm.T.userEditPreferredProgrammingLanguage))
        ]),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.preferredLanguage,
                expression: "preferredLanguage"
              }
            ],
            staticClass: "custom-select",
            attrs: { "data-preferred-language": "" },
            on: {
              change: function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.preferredLanguage = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              }
            }
          },
          [
            _c("option", { attrs: { value: "" } }),
            _vm._l(Object.entries(_vm.programmingLanguages), function(ref) {
              var extension = ref[0]
              var name = ref[1]
              return _c(
                "option",
                { key: extension, domProps: { value: extension } },
                [_vm._v(" " + _vm._s(name) + " ")]
              )
            })
          ],
          2
        )
      ]),
      _c("div", { staticClass: "form-group" }, [
        _c("label", [
          _vm._v(_vm._s(_vm.T.userObjectivesModalDescriptionUsage))
        ]),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.learningTeachingObjective,
                expression: "learningTeachingObjective"
              }
            ],
            staticClass: "custom-select",
            attrs: { "data-learning-teaching-objective": "" },
            on: {
              change: function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.learningTeachingObjective = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              }
            }
          },
          [
            _c(
              "option",
              { domProps: { value: _vm.ObjectivesAnswers.Learning } },
              [
                _vm._v(
                  " " + _vm._s(_vm.T.userObjectivesModalAnswerLearning) + " "
                )
              ]
            ),
            _c(
              "option",
              { domProps: { value: _vm.ObjectivesAnswers.Teaching } },
              [
                _vm._v(
                  " " + _vm._s(_vm.T.userObjectivesModalAnswerTeaching) + " "
                )
              ]
            ),
            _c(
              "option",
              {
                domProps: { value: _vm.ObjectivesAnswers.LearningAndTeaching }
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.T.userObjectivesModalAnswerLearningAndTeaching) +
                    " "
                )
              ]
            ),
            _c("option", { domProps: { value: _vm.ObjectivesAnswers.None } }, [
              _vm._v(" " + _vm._s(_vm.T.userObjectivesModalAnswerNone) + " ")
            ])
          ]
        )
      ]),
      _c("div", { staticClass: "form-group" }, [
        _c("label", [_vm._v(_vm._s(_vm.scholarCompetitiveObjectiveQuestion))]),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.scholarCompetitiveObjective,
                expression: "scholarCompetitiveObjective"
              }
            ],
            staticClass: "custom-select",
            attrs: {
              disabled:
                _vm.learningTeachingObjective === _vm.ObjectivesAnswers.None,
              "data-scholar-competitive-objective": ""
            },
            on: {
              change: function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.scholarCompetitiveObjective = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              }
            }
          },
          [
            _c(
              "option",
              { domProps: { value: _vm.ObjectivesAnswers.Scholar } },
              [
                _vm._v(
                  " " + _vm._s(_vm.T.userObjectivesModalAnswerScholar) + " "
                )
              ]
            ),
            _c(
              "option",
              { domProps: { value: _vm.ObjectivesAnswers.Competitive } },
              [
                _vm._v(
                  " " + _vm._s(_vm.T.userObjectivesModalAnswerCompetitive) + " "
                )
              ]
            ),
            _c(
              "option",
              {
                domProps: { value: _vm.ObjectivesAnswers.ScholarAndCompetitive }
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.T.userObjectivesModalAnswerScholarAndCompetitive
                    ) +
                    " "
                )
              ]
            ),
            _c("option", { domProps: { value: _vm.ObjectivesAnswers.Other } }, [
              _vm._v(" " + _vm._s(_vm.T.userObjectivesModalAnswerOther) + " ")
            ])
          ]
        )
      ]),
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("label", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.isPrivate,
                  expression: "isPrivate"
                }
              ],
              staticClass: "mr-2",
              attrs: { type: "checkbox", "data-is-private": "" },
              domProps: {
                checked: _vm.isPrivate,
                checked: Array.isArray(_vm.isPrivate)
                  ? _vm._i(_vm.isPrivate, null) > -1
                  : _vm.isPrivate
              },
              on: {
                change: [
                  function($event) {
                    var $$a = _vm.isPrivate,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.isPrivate = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.isPrivate = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.isPrivate = $$c
                    }
                  },
                  _vm.handlePrivateProfileCheckboxChange
                ]
              }
            }),
            _vm._v(_vm._s(_vm.T.userEditPrivateProfile) + " ")
          ]),
          _c(
            "b-button",
            {
              staticClass: "ml-1",
              attrs: {
                id: "popover-private-profile",
                size: "sm",
                variant: "none"
              },
              on: {
                click: function($event) {
                  _vm.show = !_vm.show
                }
              }
            },
            [
              _c("font-awesome-icon", {
                attrs: { icon: ["fas", "question-circle"] }
              })
            ],
            1
          ),
          _c(
            "b-popover",
            {
              attrs: {
                show: _vm.show,
                target: "popover-private-profile",
                variant: "danger",
                placement: "right"
              },
              on: {
                "update:show": function($event) {
                  _vm.show = $event
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function() {
                    return [
                      _vm._v(_vm._s(_vm.T.profilePrivateRankMessageTitle))
                    ]
                  },
                  proxy: true
                }
              ])
            },
            [_vm._v(" " + _vm._s(_vm.T.profilePrivateRankMessage) + " ")]
          )
        ],
        1
      ),
      _c("div", { staticClass: "form-group" }, [
        _c("label", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.hideProblemTags,
                expression: "hideProblemTags"
              }
            ],
            staticClass: "mr-2",
            attrs: { type: "checkbox", "data-hide-problem-tags": "" },
            domProps: {
              checked: _vm.hideProblemTags,
              checked: Array.isArray(_vm.hideProblemTags)
                ? _vm._i(_vm.hideProblemTags, null) > -1
                : _vm.hideProblemTags
            },
            on: {
              change: function($event) {
                var $$a = _vm.hideProblemTags,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.hideProblemTags = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.hideProblemTags = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.hideProblemTags = $$c
                }
              }
            }
          }),
          _vm._v(_vm._s(_vm.T.userEditHideProblemTags) + " ")
        ])
      ]),
      _c("div", { staticClass: "mt-3" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-primary mr-2",
            attrs: { type: "submit", "data-preference-save-button": "" }
          },
          [_vm._v(" " + _vm._s(_vm.T.wordsSaveChanges) + " ")]
        ),
        _c(
          "a",
          { staticClass: "btn btn-cancel", attrs: { href: "/profile/" } },
          [_vm._v(_vm._s(_vm.T.wordsCancel))]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }